import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppFacade } from '@app/app.facade';

@Pipe({
  name: 'frequentFlyerName',
  standalone: false
})
export class FrequentFlyerNamePipe implements PipeTransform {

  constructor(
    private facade: AppFacade
  ) { }

  transform(code: string): Observable<string> {
    return this.facade.frequentFlyerPrograms$
      .pipe(
        map(programs => {
          if (code && programs) {
            const program = programs.find(item => item.airline_code?.includes(code));
            return program?.program_name ? program.program_name.trim() : '';
          } else return '';
        })
      );
  }
}
